"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALES = exports.LOCALE_REGISTRY = exports.DEFAULT_LOCALE = void 0;
exports.DEFAULT_LOCALE = "en";
exports.LOCALE_REGISTRY = Object.freeze({
    [exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Español"
    },
    fr: {
        label: "Français"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "한국어"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "日本語"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Português"
    },
    ru: {
        label: "русский"
    },
    zh: {
        label: "中文"
    }
});
exports.LOCALES = Object.keys(exports.LOCALE_REGISTRY);
//# sourceMappingURL=localization.constants.js.map